// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section {
  padding-top: var(--mobile-padding-size, 40px);
  padding-bottom: var(--mobile-padding-size, 40px);
}
.section.section--vertical-padding-none {
  padding-top: 0;
  padding-bottom: 0;
}
.section.section--vertical-padding-top-only {
  padding-bottom: 0;
}
.section.section--vertical-padding-bottom-only {
  padding-top: 0;
}

@media (min-width: 960px) {
  .section {
    padding-top: var(--padding-size, 40px);
    padding-bottom: var(--padding-size, 40px);
  }
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/sections.scss"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,gDAAA;AACF;AACE;EACE,cAAA;EACA,iBAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;AAGE;EACE,cAAA;AADJ;;AAKA;EACE;IACE,sCAAA;IACA,yCAAA;EAFF;AACF","sourcesContent":[".section {\n  padding-top: var(--mobile-padding-size, 40px);\n  padding-bottom: var(--mobile-padding-size, 40px);\n\n  &.section--vertical-padding-none {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  \n  &.section--vertical-padding-top-only {\n    padding-bottom: 0;\n  }\n  \n  &.section--vertical-padding-bottom-only {\n    padding-top: 0;\n  }\n}\n\n@media (min-width: 960px) {\n  .section {\n    padding-top: var(--padding-size, 40px);\n    padding-bottom: var(--padding-size, 40px);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
